import PhoneInput from "../../../atoms/controls/input/PhoneInput";
import ErrorMessage from "../../../atoms/controls/validation/ErrorMessage";
import { phoneCode } from "../../../../helpers/phoneCode";
import DropdownSelect from "../select/DropdownSelect";

export default function PhoneInputField({
  id,
  label,
  value,
  onChange,
  error,
  required,
  disabled,
  countryCode,
  formikTouched,
  ...props
}) {
  if (
    !countryCode ||
    countryCode === null ||
    countryCode === "null" ||
    countryCode === ""
  ) {
    countryCode = "TR";
  }
  const prefix = phoneCode.find(
    (c) => c.code === countryCode.toUpperCase()
  )?.dial_code;
  return (
    <div>
      <div className="flex gap-2">
        <div className="w-20">
          <DropdownSelect
            value={prefix}
            disabled={true}
            options={phoneCode.map((item) => ({
              value: item.dial_code,
              label: item.dial_code,
            }))}
          />
        </div>
        <div className="flex-1">
          <PhoneInput
            id={id}
            value={value}
            onChange={onChange}
            error={error}
            required={required}
            disabled={disabled}
            countryCode={countryCode}
            touched={formikTouched}
            {...props}
          />
        </div>
      </div>
      <ErrorMessage touched={formikTouched} errors={error} />
    </div>
  );
}
